import { render, staticRenderFns } from "./tijianPackage.vue?vue&type=template&id=5fe4d497&scoped=true&"
import script from "./tijianPackage.vue?vue&type=script&lang=js&"
export * from "./tijianPackage.vue?vue&type=script&lang=js&"
import style0 from "./tijianPackage.vue?vue&type=style&index=0&id=5fe4d497&lang=scss&scoped=true&"
import style1 from "./tijianPackage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe4d497",
  null
  
)

export default component.exports